module.exports = __webpack_public_path__ + "static/media/SignUp4Wave.4d518286.svg";